import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import ClientHeader from "../ClientHeader/ClientHeader";
import HeroSearchSection from "./components/HeroSearchSection";
import CategoriesGrid from "./components/CategoriesGrid";
import FAQSection from "./components/FAQSection";
import ContactSupportSection from "./components/ContactSupportSection";

const ClientHelpCenter: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedFaq, setExpandedFaq] = useState<string | false>(false);

  const handleFaqChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedFaq(isExpanded ? panel : false);
    };

  const handleCategoryClick = (_categoryId: string) => {
    document.getElementById("faq-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box sx={{ backgroundColor: "#FAF8F5", minHeight: "100vh" }}>
      <ClientHeader />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <HeroSearchSection searchQuery={searchQuery} onChange={setSearchQuery} />
        <CategoriesGrid onCategoryClick={handleCategoryClick} />
        <FAQSection expandedFaq={expandedFaq} onFaqChange={handleFaqChange} />
        <ContactSupportSection />
      </Container>
    </Box>
  );
};

export default ClientHelpCenter;
